module.exports = __webpack_public_path__ + "img/ico-search.259c5274.svg";